import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NoResourcesComponent } from './no-resources.component';


@NgModule({
  declarations: [NoResourcesComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  exports: [NoResourcesComponent]
})
export class NoResourcesModule { }
